import { Typography } from '@mui/material';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { InhaltWrapper } from 'src/pages/private/online-antrag/antrag-components/Wrapper';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const KurzbeschreibungEPZ: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<ApplicationHeading title='Projektbeschreibung' description={PLATZHALTER_TEXT} />
			<InhaltWrapper marginTop='0'>
				<Typography>
					Bitte beschreiben Sie Ihr geplantes Projekt möglichst konkret. Es muss eindeutig ersichtlich sein, dass das Projekt unter den
					Fördergegenstand fällt.
				</Typography>
				<Typography>
					<strong>Leitfragen für Auslandsprojekte:</strong> Wo findet das Projekt statt? Welche konkrete Problemlage wird adressiert? Wie
					verbessert das Projekt nachhaltig die Lebensbedingungen betroffener Menschen vor Ort bzw. trägt dazu bei, die Problemlage zu
					verbessern/beheben? Ist es ein partnerschaftliches Projekt, das auf Entwicklungsansätzen und -initiativen der Partner aus dem Globalen
					Süden oder auf einem gemeinsamen Interesse beider Seiten beruht?
				</Typography>
				<Typography>
					<strong>Leitfragen für Inlandsprojekte:</strong> Wo findet das Projekt statt? Wie trägt das Projekt dazu bei, Bewusstsein für die
					Lebenssituation der Menschen im Globalen Süden zu schaffen? Vermittelt das Projekt Wissen und zeigt es einen Handlungsbezug auf?
				</Typography>
			</InhaltWrapper>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />

			<ApplicationHeading title='Projektzusammenfassung' description={PLATZHALTER_TEXT} />
			<InhaltWrapper marginTop='0'>
				<Typography>Bitte fassen Sie Ihr Projekt kurz und prägnant zusammen.</Typography>
			</InhaltWrapper>
			<CreateForm
				formStruc={formStrucZusammenfassung()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
		</>
	);
};

export default KurzbeschreibungEPZ;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Kurzbeschreibung,
					label: 'Projektbeschreibung',
					maxCharLength: 2500,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucZusammenfassung = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Projektbeschreibung_Entw_0140376423_ibung_Projektzusammenfassung,
					maxCharLength: 500,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucKurzbeschreibungEPZ = (_application: any) => {
	return concat(formStruc(), formStrucZusammenfassung());
};
